import React from "react";

const InfoCard = React.memo(function InfoCard({ question }) {
  return (
    <div
      className="px-6 py-6 desktop:px-8 desktop:py-6 rounded-2xl border border-white/10 bg-white/[0.02]"
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5 w-7 h-7 rounded-full bg-blue/20 flex items-center justify-center">
          <i className="fa-solid fa-circle-info text-[10px] text-blue" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-white/80 font-sans text-sm desktop:text-base font-semibold mb-2">
            {question.question}
          </h3>
          {question.subtext && (
            <p className="text-white/40 font-sans text-xs desktop:text-sm leading-relaxed whitespace-pre-line">
              {question.subtext}
            </p>
          )}
        </div>
      </div>
    </div>
  );
});

export default InfoCard;
